import React, { useState } from 'react';

import Autocomplete from '@mui/material/Autocomplete';

import HelperTextError from 'components/mui/Form/TextField/HelperTextError';
import TextField from '@mui/material/TextField';
import EmailTag from 'pages/common/Dialog/components/EmailTag';
import UserOptionLabel from 'pages/common/Dialog/components/UserOptionLabel';

const EMAILS_LIMIT = 12;

const EmailAutocomplete = ({
  emailOptions,
  users,
  input: { value, onChange, onBlur, ...FormInputProps },
  label: inputLabel,
  meta,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState('');
  const isError = Boolean(meta.touched && meta.error);

  return (
    <Autocomplete
      {...rest}
      multiple
      autoHighlight
      id={inputLabel}
      value={value || []}
      onChange={(event, newValue) => onChange(newValue)}
      inputValue={inputValue}
      onBlur={() => {
        onBlur(value);
        if (inputValue) {
          onChange([...value, inputValue]);
          setInputValue('');
        }
      }}
      onInputChange={(e, newValue) => {
        if (value.length + 1 <= EMAILS_LIMIT) {
          setInputValue(newValue);
        }
      }}
      filterSelectedOptions
      options={value.length + 1 <= EMAILS_LIMIT ? emailOptions : []}
      renderOption={(props, tag) => <UserOptionLabel tag={tag} users={users} {...props} />}
      getOptionLabel={(option) => (users[option] ? `${users[option].username} ${users[option].userId}` : option)}
      freeSolo
      renderValue={(values, getTagProps) =>
        values.map((tag, index) => <EmailTag key={tag} tag={tag} users={users} {...getTagProps({ index })} />)
      }
      renderInput={({ inputProps, InputLabelProps, InputProps, ...params }) => {
        return (
          <TextField
            {...params}
            slotProps={{
              htmlInput: inputProps,
              input: {
                ...(InputProps || {}),
                ...(FormInputProps || {}),
              },
              inputLabel: InputLabelProps,
            }}
            label={inputLabel}
            error={isError}
            helperText={<HelperTextError isError={isError} meta={meta} />}
          />
        );
      }}
    />
  );
};

export default EmailAutocomplete;
